export default __webpack_public_path__ + "static/media/bank-zkb.ca08a83c.svg";